import React, {
    useState,
    useEffect,
} from 'react';
import {
    Dialog,
    Slide,
} from "@material-ui/core";
import {EmployeeModal} from "../../../Common/Views/Modals/EmployeeModal/EmployeeModal";
import TransitionProps from '@material-ui/core/transitions/transition';
import CourseViewHeader from "../Views/CourseViewHeader";
import Employee from "../../../Common/Models/Employee";
import CourseViewBody from "../Views/CourseViewBody";
import CourseViewFooter from "../Views/CourseViewFooter";
import Course from "../../../Common/Models/Course";

const transition = React.forwardRef(function Transition(
    //@ts-ignore
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export const CourseViewController = (props: any) => {
    const {
        open,
        course,
        dismiss,
    } = props;
    const [employee, setEmployee] = useState<any>();
    const [openProfile, setOpenProfile] = useState(false);

    const getInstructor = async (course: Course): Promise<Employee | null>  => {
        if (course?.instructor) {
            const controller: AbortController = new AbortController();
            const signal = controller.signal;
            const id = course.instructor;

            const url = `https://idverify.manhattan.edu/apiv2/api/AlgoliaProxy/employees/${id}`;

            const res = await fetch(url, {
                signal,
                mode: 'cors',
            });

            const json = await res.json();

            return  json ? {
                email: json.EMPL_EMAIL,
                fullName: json.EMPL_FULL_NAME,
                id: json.objectID,
                imageURL: json.imgurl?.replace("http", "https") || "" ,
                location:  json.EMPL_OFFICE,
                phone: json.EMPL_OFFICE_FTELE,
                title: json.TITLEDEPT,
                title_2:  json.TITLEDEPT_2,
                imageThumbnailURL: json.imgurl_thumbnail?.replace("http", "https") || "",
            } : null;
        }

        return null;
    }

    useEffect(() => {
                getInstructor(course).then((instructor) => {
                    if (instructor)
                        setEmployee(instructor);
                });
    }, [course]);

    return (
        <Dialog
            fullScreen
            TransitionComponent={transition}
            open={open}
            onClose={dismiss}
        >
            <CourseViewHeader title={course?.title} />
            <CourseViewBody employee={employee} course={course} onSelectEmployee={() => setOpenProfile(true)} />
            <CourseViewFooter onDismiss={dismiss} />
            <EmployeeModal open={openProfile} employee={employee} dismiss={() => setOpenProfile(false)}/>
        </Dialog>
    );
};